module.exports = {"yytx20":{"daobanList":[{"title":"1:是否办理就业登记","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、个人就业登记申请表","state":"必要"},{"name":"2、本人基本身份类证明（居民身份证（户口簿）、香港特区护照/港澳居民来往内地通行证、澳门特区护照/港澳居民来往内地通行证、台湾居民来往大陆通行证、港澳台居民居住证）","state":"必要"},{"name":"3、2寸彩照一张（打印《就业创业证》需提供）","state":"非必要"},{"name":"4、就业创业证（打印信息记录需提供）","state":"非必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx20.json
// module id = 1318
// module chunks = 0